import { en, de } from 'n2words';
import i18n from './i18n';

// Somali is not offered by n2words. Keep its numeral grammar isolated and tested.
const units = ['eber', 'kow', 'laba', 'saddex', 'afar', 'shan', 'lix', 'toddoba', 'siddeed', 'sagaal'];
const tens = ['', 'toban', 'labaatan', 'soddon', 'afartan', 'konton', 'lixdan', 'toddobaatan', 'siddeetan', 'sagaashan'];
const somali = n => {
  if (n < 10) return units[n];
  if (n < 100) return (n % 10 ? `${units[n % 10]} iyo ` : '') + tens[Math.floor(n / 10)];
  for (const [size, word] of [[1e9, 'bilyan'], [1e6, 'milyan'], [1000, 'kun'], [100, 'boqol']]) {
    if (n >= size) return `${Math.floor(n / size) === 1 ? 'hal' : somali(Math.floor(n / size))} ${word}${n % size ? ' iyo ' + somali(n % size) : ''}`;
  }
  return '';
};

export const amountInWords = (value, currency) => {
  const cents = Math.round(Number(value) * 100);
  if (!Number.isSafeInteger(cents) || cents < 0) return '';
  const whole = Math.floor(cents / 100), fraction = cents % 100;
  const language = i18n.resolvedLanguage || 'en';
  const spell = language === 'so' ? somali : language === 'de' ? de : en;
  const unitsByLanguage = { so: { EUR: 'yuuro', USD: 'doolar Maraykan', TRY: 'liira Turki', GBP: 'giniga Ingiriiska' }, de: { EUR: 'Euro', USD: 'US-Dollar', TRY: 'türkische Lira', GBP: 'Pfund Sterling' }, en: { EUR: 'euro', USD: 'US dollar', TRY: 'Turkish lira', GBP: 'pound sterling' } };
  const unit = (unitsByLanguage[language]?.[currency] || currency) + (language === 'en' && whole !== 1 && ['EUR', 'USD'].includes(currency) ? 's' : '');
  const join = language === 'so' ? 'iyo' : language === 'de' ? 'und' : 'and';
  const centUnit = currency === 'TRY' ? 'kuruş' : currency === 'GBP' ? (fraction === 1 ? 'penny' : 'pence') : language === 'so' ? 'senti' : language === 'de' ? 'Cent' : fraction === 1 ? 'cent' : 'cents';
  return `${spell(whole)} ${unit}${fraction ? ` ${join} ${spell(fraction)} ${centUnit}` : ''}`;
};